import Link from 'next/link';
import { IoArrowForward } from 'react-icons/io5';

import { Anchor, Box, Group, SimpleGrid, Stack, Text, Title } from '@mantine/core';

import { MarketingHelpers } from 'helpers/MarketingHelpers';
import { RouterHelpers } from 'helpers/RouterHelpers';

import { DCIDE } from 'components/logo/DCIDE';
import { DCIDEController } from 'components/logo/DCIDEController';
import { ReplusLogo } from 'components/logo/ReplusLogo';

import cx from './Dashboard.module.scss';

const teasers = [
    {
        logo: <DCIDE height={28} />,
        title: 'Design DC Power Systems',
        description:
            'From first sketch to full topology - prototype, simulate, and validate with real engineering models.',
        href: MarketingHelpers.urls.dcide.overview(),
    },
    {
        logo: <ReplusLogo h={36} w="auto" />,
        title: 'Find Products & Professionals',
        description:
            'Find products, professionals, and partners - everything you need to design and deploy your next power system project.',
        href: RouterHelpers.urls.products.overview(),
    },
    {
        logo: <DCIDEController height={42} />,
        title: 'Accelerate Deployment of DC Microgrids',
        description:
            'Plug-and-play automation for DC microgrids - connect any hardware, run smart energy algorithms, and monitor everything in real time.',
        href: MarketingHelpers.urls.controller.overview(),
    },
];

const DashboardDiscover = () => (
    <Stack gap="xl">
        <Stack gap={4} align="center" ta="center">
            <Title order={2} fz={{ base: 28, md: 36 }} fw={800} lh={1.15}>
                Explore the <span className="gradient-cyan-green">Platform</span>
            </Title>
            <Text c="dimmed" fz="lg">
                Everything you need to design and deploy your next power system project.
            </Text>
        </Stack>

        <SimpleGrid cols={{ base: 1, md: 3 }} spacing="lg">
            {teasers.map(({ logo, title, description, href }) => (
                <Box key={title} className={cx.teaser}>
                    <Box h={36} display="flex" style={{ alignItems: 'center' }}>
                        {logo}
                    </Box>
                    <Text fz={22} fw={800} lh={1.2} mt="lg">
                        {title}
                    </Text>
                    <Text c="dimmed" mt="xs">
                        {description}
                    </Text>
                    <Anchor component={Link} href={href} size="sm" fw={600} mt="auto" pt="lg" className={cx.teaserLink}>
                        <Group gap={4} component="span">
                            Learn more
                            <IoArrowForward size={14} />
                        </Group>
                    </Anchor>
                </Box>
            ))}
        </SimpleGrid>
    </Stack>
);

export { DashboardDiscover };
